import React, { ReactElement } from 'react'

import { IconProps } from '@hhgtech/hhg-components'
import { Text } from '@hhgtech/hhg-components/mantine'
import { BoxProps, HoverCard, rem } from '@mantine/core'

import { DataTrackingTypeHTMLElement, ScrollToItemType } from 'interfaces/types'

import { FlatIcon } from './flatIcon'

export type BlockItemPropsType = {
  icon?: ReactElement<IconProps>
  iconSize?: number
  image?: string
  isImageBg?: boolean
  layout?: 'horizon' | 'vertical'
  bgColor?: string
  useBgColor?: boolean
  iconColor?: string
  fullWidth?: boolean
  hideTitle?: boolean
  isSelected?: boolean
  isQuare?: boolean
  isExternalUrl?: boolean
  hideDescription?: boolean
  showBrushPattern?: boolean
  useImgAsFullBg?: boolean
  onClick?: () => void
} & ScrollToItemType &
  BoxProps &
  DataTrackingTypeHTMLElement

// type Props = {
//   title?: string
//   hasHover?: boolean
//   // displayAs?: FC<BlockItemPropsType>
//   displayAs?: any
// } & BlockItemPropsType

const BlockItem = (props: any) => {
  const {
    title,
    hasHover,
    displayAs = FlatIcon,
    onClick,
    item,
    ...otherProps
  } = props
  const DisplayComp = displayAs

  return hasHover ? (
    <HoverCard
      position="right"
      openDelay={0.2}
      offset={8}
      shadow="sm"
      styles={{
        dropdown: { border: 0, padding: rem(8) },
      }}
    >
      <HoverCard.Target>
        <DisplayComp
          component="a"
          title={title}
          {...item}
          {...otherProps}
          onClick={onClick}
        />
      </HoverCard.Target>
      <HoverCard.Dropdown>
        <Text size="p4" weight="semiBold">
          {title}
        </Text>
      </HoverCard.Dropdown>
    </HoverCard>
  ) : (
    <DisplayComp
      component="a"
      title={title}
      {...item}
      {...otherProps}
      onClick={onClick}
    />
  )
}

export { BlockItem }
